import React, { useEffect, useState } from "react";
import DevicesTable from "./components/DevicesTable";
import Divider from "@material-ui/core/Divider/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import Filter from "./modals/Filter";

function Devices(props) {
  const [devices, setDevices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteDevicesIds, setDeleteDevicesIds] = useState([]);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [showFilter, setShowFilter] = React.useState(false);
  const [filterInputs, setFilterInputs] = useState({
    appointment: "",
    deviceModelId: "",
    devicePlaceId: "",
    deviceTypeId: "",
    direction: "",
    ipAddress: "",
    name: "",
    status: "",

  });

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onDevices = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {

      appointment,
      deviceModelId,
      devicePlaceId,
      deviceTypeId,
      direction,
      ipAddress,
      name,
      status,


    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}device/report?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${appointment ? `&appointment=${appointment}` : ""}${deviceModelId ? `&deviceModelId=${deviceModelId}` : ""}${devicePlaceId ? `&devicePlaceId=${devicePlaceId}` : ""}${deviceTypeId ? `&deviceTypeId=${deviceTypeId}` : ""}${direction ? `&direction=${direction}` : ""}${ipAddress ? `&ipAddress=${ipAddress}` : ""}${name ? `&name=${name}` : ""}${status ? `&status=${status}` : ""}`)
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setDevices(content);
        setIsError(false);
        setCount(totalElements)
        setShowFilter(false)

      })
      .catch(() => {
        setIsLoading(false);
        setDevices([]);
        setIsError(true);
      });
  };


  const onDeviceFilterExport = () => {

    axios
      .get(`${process.env.REACT_APP_API_URL}device/report/export?${filterInputs.appointment ? `&appointment=${filterInputs.appointment}` : ""}${filterInputs.deviceModelId ? `&deviceModelId=${filterInputs.deviceModelId}` : ""}${filterInputs.devicePlaceId ? `&devicePlaceId=${filterInputs.devicePlaceId}` : ""}${filterInputs.deviceTypeId ? `&deviceTypeId=${filterInputs.deviceTypeId}` : ""}${filterInputs.direction ? `&direction=${filterInputs.direction}` : ""}${filterInputs.ipAddress ? `&ipAddress=${filterInputs.ipAddress}` : ""}${filterInputs.name ? `&name=${filterInputs.name}` : ""}${filterInputs.status ? `&status=${filterInputs.status}` : ""}`,

        {
          responseType: "blob",

        }
      ).then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "Device-report.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };


  useEffect(() => {
    const timer = setTimeout(() => {
      onDevices(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  const [devicePlaceId, setDevicePlaceId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}devicePlace`)
      .then(({ data: { content } }) => {
        const models = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDevicePlaceId(models);
      });
  }, []);
  const [deviceTypeId, setDeviceTypeId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceType`)
      .then(({ data: { content } }) => {
        const deviceTypeId = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceTypeId(deviceTypeId);
      });
  }, []);

  const [deviceModelId, setDeviceModelId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}deviceModel`)
      .then(({ data: { content } }) => {
        const deviceModelId = content.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setDeviceModelId(deviceModelId);
      });
  }, []);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h1 className="display-4 mb-0">Qurğular hesabatı</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <DevicesTable
        devices={devices}
        isLoading={isLoading}
        isError={isError}
        setDeleteDevicesIds={setDeleteDevicesIds}
        deleteDevicesIds={deleteDevicesIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        onDeviceFilterExport={onDeviceFilterExport}
      />

      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        devicePlaceId={devicePlaceId}
        deviceTypeId={deviceTypeId}
        deviceModelId={deviceModelId}
      />
    </div>
  );
}

export default Devices;
